const CHANNEL_NAME = "pico-broadcast";

const channel =
  typeof window !== "undefined" && "BroadcastChannel" in window
    ? new BroadcastChannel(CHANNEL_NAME)
    : null;

export interface BroadcastMessage<T = unknown> {
  type: string;
  payload?: T;
}

export function broadcast<T>(message: BroadcastMessage<T>): void {
  channel?.postMessage(message);
}

export function subscribeBroadcast(handler: (message: BroadcastMessage) => void): () => void {
  if (!channel) return () => {};
  const listener = (event: MessageEvent<BroadcastMessage>) => {
    handler(event.data);
  };
  channel.addEventListener("message", listener);
  return () => {
    channel.removeEventListener("message", listener);
  };
}
